import styled from 'styled-components';
import { MTextBlockStandardAlignment } from './MTextBlockStandard.types';

const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

export const Wrapper = styled.div<{
  alignment: MTextBlockStandardAlignment;
}>`
  display: flex;
  flex-direction: column;
  text-align: ${({ alignment }) => (alignment === MTextBlockStandardAlignment.Center ? 'center' : 'left')};
  row-gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
`;
